<script>
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Utils from "@/common/Utils";
import Constants from "@/common/Constants";
import GenericCustomMasterDataAutocompleteV2 from "@/components/generic/GenericCustomMasterDataAutocompleteV2"
import GenericDataTable from "@/components/generic/GenericDataTable"
import config from '@/common/genericPanelConf';
import Service from '@/services/fiscal-notification'
import ProgressSpinner from 'primevue/progressspinner';
import LabelField from "@/components/generic/LabelField.vue";

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { GenericCustomMasterDataAutocompleteV2, GenericDataTable, ProgressSpinner, LabelField },
    data(){
        return{
            submitted: false,
            filters: {
                dateFrom: Utils.formatDatePlusDays(new Date(), -90),
                dateTo: Utils.formatDatePlusDays(new Date(), 0),
                register: null
            },
            configuration: {},
            importDialogVisible: false,
            importDialog: {
                from: null,
                to: null,
                registerCode: null
            },
            stockVisible: false,
            stockLoading: false,
            stockData: []
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'versalisRegister.raw_materials_movements_page_title');
    },
    validations(){
        return {
            filters: {
                dateFrom: {required},
                dateTo: {required},
                register: {required}
            }
        }
    },
    created(){
        this.configuration = config.getConfiguration('VersalisMovementsRawMaterial');
    },
    computed: {
        constants: () => Constants,
        utils: () => Utils,
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        load(valid){
            this.submitted = true;

            if (!valid){
                return;
            }

            let body = [];
            body.push({
                operator: '>=',
                value: this.filters.dateFrom,
                property: 'MovementDate'
            });

            body.push({
                operator: '<=',
                value: Utils.formatEndDate(this.filters.dateTo),
                property: 'MovementDate'
            });

            body.push({
                operator: 'eq',
                value: this.filters.register,
                property: 'ProtocolNumber'
            });

            this.$refs.grid.filterFromView(body);

            this.loadStock();
        },
        loadStock(){
            this.stockData = [];
            this.stockLoading = true;
            Service.getVersalisMovementRawMaterialLast(response => {
                this.stockLoading = false;
                if(response.success){
                    this.stockData = response.data;
                }
            })
        },
        formatDecimal(n, digits, showZero){
            if(!digits){
                digits = 2;
            }
            if(n){
                return n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits});
            }
            return showZero ? 0 : null;
            
        },
        dowloadExcel(){
            this.$store.dispatch("generic/setLoading", true);
            let filters = {
                from: Utils.formatDateForAPIWithTime(Utils.formatDatePlusDays(this.filters.dateFrom, 0)), //Utils.formatDateForAPIWithTime(this.filters.from),
                to: Utils.formatDateForAPIWithTime(Utils.formatEndDate(this.filters.dateTo)),
                protocolNumber: this.filters.register
            }
            Service.versalisMovementRawMaterialExcel(filters, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    let fileName = "Report.xlsx";
                    fileLink.setAttribute('download',fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        openImportDialog(){
            this.importDialog = {
                from: Utils.formatDatePlusDays(new Date(), -7),
                to: Utils.formatDatePlusDays(new Date(), -1),
                registerCode: this.filters.register
            }
            this.importDialogVisible = true;
        },
        importData(){
            let body = {
                from: Utils.formatDateForAPI(this.importDialog.from),
                to: Utils.formatDateForAPI(this.importDialog.to),
                registerCode: this.importDialog.registerCode
            }
            Service.versalisMovementRawMaterialImport(body, response => {
                if(response.success){
                    this.importDialogVisible = false;
                    this.load(true)
                }else{
                    this.$toast.add({ detail: response.message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        onItemEditSave(item){
            if(item.id){
                Service.updateVersalisMovementRawMaterial(item, response => {
                    if(response.success){
                        this.importDialogVisible = false;
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.$refs.grid.hideDialogEdit();
                        this.load(true);
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }else{
                Service.createVersalisMovementRawMaterial(item, response => {
                    if(response.success){
                        this.importDialogVisible = false;
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.$refs.grid.hideDialogEdit();
                        this.load(true);
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
            
        }
    }
}

</script>

<template>
    <main>
        <Dialog v-model:visible="importDialogVisible" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12 ">
                    <label for="month">{{$t('DailyProfiles.startDate')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        dateFormat="dd/mm/yy"
                        :showTime="false"
                        v-model="importDialog.from"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 ">
                    <label for="month">{{$t('DailyProfiles.endDate')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        dateFormat="dd/mm/yy"
                        :showTime="false"
                        v-model="importDialog.to"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 ">
                    <label for="familyPool">{{$t('VersalisMovements.IDREG_PROTOCOL_NUM')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        :class="{'p-inputtext-sm w-full': true}"
                            :name="'versalis-registers'"
                            v-model="importDialog.registerCode"
                            :api="'masterdata/versalis-register-combo'"/>
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="importDialogVisible = false"></Button>
                <Button type="button" class="m-2" :label="$t('btn.import')" icon="pi pi-save" @click="importData"></Button>
            </div>
        </Dialog>

        <div class="formgrid grid">
            
            <div class="col-12 lg:col-2 field">
                <label for="from" :class="{'p-error':v$.filters.dateFrom.$invalid && submitted}">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateFrom.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateFrom.$invalid && submitted) || v$.filters.dateFrom.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateFrom.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="to" :class="{'p-error':v$.filters.dateTo.$invalid && submitted}">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateTo.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateTo.$invalid && submitted) || v$.filters.dateTo.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateTo.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="familyPool" :class="{'p-error':v$.filters.register.$invalid && submitted}">{{$t('VersalisMovements.IDREG_PROTOCOL_NUM')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    :class="{'p-invalid':v$.filters.register.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                        :name="'versalis-registers'"
                        v-model="filters.register"
                        :api="'masterdata/versalis-register-combo'"/>
                <div v-if="(v$.filters.register.$invalid && submitted) || v$.filters.register.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.register.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-4 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="p-button-sm m-1" @click="load(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('btn.import')" :disabled="!uiPermissions('VersalisMovementsRawMaterialInsertButton').isEnabled" icon="pi pi-plus" class="p-button-sm p-button-outlined m-1" @click="openImportDialog"/>
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="dowloadExcel"/>
                <ResponsiveButton :label="$t('btn.stock')" icon="pi pi-database" class="p-button-sm p-button-outlined m-1" @click="stockVisible = !stockVisible"/>
            </div>
        </div>

        <div class="grid">
            <Card :class="{'col-12': !stockVisible, 'col-8': stockVisible}">
                <template #content>
                    <GenericDataTable :configuration="configuration" :category="'versalis'" :name="'grid'" ref="grid" :onDialogEditSave="onItemEditSave" />
                </template>
            </Card>
            <div class="col-4" style="display: flex; justify-content: center;" v-if="stockLoading && stockVisible">
                <ProgressSpinner style="margin:0 auto" />
            </div>
            <div class="col-4" v-if="!stockLoading && stockVisible">
                <div class="grid flex">
                    <div v-for="item in stockData" :key="item.id" class="col-12 lg:col-6">
                        <Card class="m-1">
                            <template #title>
                                {{ item.protocolNumber }} al {{ utils.formatDate(item.movementDate) }}
                            </template>
                            <template #content>
                                <div >
                                    <LabelField :label="$t('VersalisMovements.GIACENZA_PESO')" :value="formatDecimal(item.stockWeight, 3, true)" />
                                    <LabelField :label="$t('VersalisMovements.GIACENZA_LITRI')" :value="formatDecimal(item.stockVolume, 3, true)" />
                                </div>
                            </template>
                        </Card>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>